import { Paper } from '@maas-components/core'
import styled from 'styled-components'

export const StyledPaper = styled(Paper)`
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
`
